@if (spinnerLoading()) {
  <div class="container-spinner">
    <div class="loading-spinner">
      <div class="cs-loader">
        <img src="/assets/logo_facturador_v.01.jpg" alt="Cargando" />
        <div class="dots">
          <span></span><span></span><span></span><span></span><span></span>
        </div>
      </div>
      @if(spinnerTitulo()){
        <h2>Cargando Punto de Venta...</h2>
        <p class="mensaje-bloqueante" role="alert">
          Será redirigido en breve. Gracias
        </p>
      }@else{
        <p class="mensaje-bloqueante" role="alert">
          No cierres esta pantalla hasta recibir un mensaje de respuesta.<br>
          Estamos procesando tu solicitud.
        </p>
      }
    </div>
  </div>
}

@if (authService.modalBienvenida()) {
  <app-modal-bienvenida />
}

<router-outlet />